import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "不含上个月，即前第2到第4个月", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "当前账号前三个月平均发货票数", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "不含上个月，即前第2到第4个月", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "主账号前三个月平均发货票数", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "潜力月均发货量", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "OPR票数", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "潜力月均销售额(元)", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "OPR金额", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "客户承诺月均发货量", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "OCR票数", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "客户承诺月均销售额（元）", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "OCR金额", -1)

import { ref, reactive, onMounted, watch, computed } from 'vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { Form } from 'ant-design-vue'
import { businessStatusEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { countryChannelRelevance } from '@/api/yuntuSales/operationsManage'
import { listByParamCodes } from '@/api/common'
import { selectForNumberValidate } from '@/utils/validate'
import { paramCodesDataFilter, findByIdDeep } from '@/utils/index'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuBusinessEditParams } from '@/typings/api/chanceManage'
import CosInput from '@/components/Antd/CosInput/index.vue'
import CustomerArea from '@/components/CustomerArea'


const __default__ = { name: 'DetailViewForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {},
    title: {},
    type: {},
    originalStatus: {},
    saleChanceRefId: { type: Boolean }
  },
  emits: ['update:value'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const useForm = Form.useForm
const formRef = ref()
const props = __props
const businessStatusEnumFilter = ref<any[]>()
const isEdit = computed(() => props.type !== 'view')
const paramCodeData = ref<{
  lbu_demand_country: ParamCodeItem[]
  lbu_products: ParamCodeItem[]
  lbu_warehouse_city: ParamCodeItem[]
  lbu_logistics_service_provider: ParamCodeItem[]
  lbu_assistance_department: ParamCodeItem[]
  lbu_failure_reason: ParamCodeItem[]
  lbu_sale_chance_type: ParamCodeItem[]
  lbu_sales_category: ParamCodeItem[],
  lbu_shipping_channel: ParamCodeItem[],
}>({
  lbu_demand_country: [], // 目的地国家（需求国家）
  lbu_products: [], // 出货渠道（云途产品）
  lbu_warehouse_city: [], // 客户归属区域
  lbu_logistics_service_provider: [], // 竞争对手
  lbu_assistance_department: [], // 协助部门
  lbu_failure_reason: [], // 未能合作原因
  lbu_sale_chance_type: [], // 云途商机类型
  lbu_sales_category: [],
  lbu_shipping_channel: []
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_demand_country',
      'lbu_products',
      'lbu_warehouse_city',
      'lbu_logistics_service_provider',
      'lbu_assistance_department',
      'lbu_failure_reason',
      'lbu_sale_chance_type',
      'lbu_sales_category',
      'lbu_shipping_channel'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    paramCodeData.value = res.data
  })
}

const isB2BProduct = computed(() => {
  const findOne = findByIdDeep(paramCodeData.value.lbu_products, dataForm.value.product)
  return findOne?.comment?.toUpperCase().includes('B2B') === true
})

onMounted(() => {
  if (props.type === 'add') {
    businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 0)
    dataForm.value.status = 0
  }
  getByParamCodes()
})

const dataForm = ref<LbuBusinessEditParams>({})

const emit = __emit
watch(
  () => props.value,
  (val) => {
    if (!val) return
    dataForm.value = val
  },
  { deep: true, immediate: true }
)
watch(
  dataForm,
  (val) => {
    emit('update:value', val)
  },
  { deep: true }
)
// 根据“目的地国家（需求国家）”的变化获取“出货渠道”
const shippingChannel = ref<ParamCodeItem[]>([])
const getShippingChannel = (val: number) => {
  const params = { paramId: val }
  countryChannelRelevance(params).then((res) => {
    shippingChannel.value = res.data
  })
}
watch(
  () => dataForm.value.requiredCountry,
  (newVal) => {
    if (newVal && newVal !== -9) {
      getShippingChannel(newVal)
    }
  }
)
const handleCountryChange = (val?: number) => {
  dataForm.value.product = undefined
  shippingChannel.value = []
}

const isFailedCooperation = ref(false)
// 客户承诺月均发货量（OCR票数） 客户承诺月均销售额（OCR金额）在商机状态变为【签约】、【准备发件】、【首次发件】、【达到承诺业务量】时，必填
const isRequired = ref(false)
const formRules = reactive({
  saleChanceRefId: [{ required: true, message: '请选择客户名称' }],
  planSaleAmount: [{ required: true && props.type !== 'view', message: '请输入OPR金额' }],
  status: [{ required: true, validator: selectForNumberValidate, message: '请选择商机状态' }],
  requiredCountry: [{ required: true, validator: selectForNumberValidate, message: '请选择目的地国家' }],
  product: [{ required: true, validator: selectForNumberValidate, message: '请选择云途产品' }],
  warehouseAttribution: [{ required: true, message: '请选择客户归属区域' }],
  competitors: [{ required: true, message: '请选择竞争对手' }],
  saleChanceType: [{ required: true, message: '请选择商机类型' }],
  failedCooperateId: [
    { required: isFailedCooperation, validator: selectForNumberValidate, message: '请选择未能合作原因' }
  ],
  remark: [{ required: isFailedCooperation, message: '请输入备注' }],
  mau: [{ required: true && props.type !== 'view', message: '请输入OPR票数' }],
  committedShipment: [{ required: isRequired, message: '请输入OCR票数' }],
  committedSaleAmount: [{ required: isRequired, message: '请输入OCR金额' }],
  competitionSituation: [{ required: true, message: '请输入竞对情况' }],
  customerSituation: [{ required: true, message: '请输入客户情况' }],
  required: [{ required: true, message: '请输入' }]
})
const { resetFields, clearValidate } = useForm(dataForm, formRules)
watch(() => props.originalStatus,
  (val) => {
    const currentStatus = props.originalStatus
    console.log(currentStatus)
    if (currentStatus === null || currentStatus === undefined) {
      return
    }
    switch (props.type) {
      case 'view':
        businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === currentStatus)
        // businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: props.type === 'add' && item.value === 6 }))
        break
      case 'edit':
        // 编辑的时候，状态只能往下选
        // 未能合作6或者未来机会8 不受控制
        if (currentStatus === 6 || currentStatus === 8) {
          businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value === 5 || item.value === 7 }))
        } else if (currentStatus === 7) {
          // 如果商机状态7达成承诺业务量，则不可变更为其他状态（新版【达到承诺业务量】商机状态可以变更为【不能合作】与【未来机会】）
          businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value !== 6 && item.value !== 8 }))
        } else if (currentStatus === 9) {
          // 准备发件
          businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value < 5 || item.value === 5 || item.value === 7 }))
        } else {
          // 其余状态只可以向后变更
          businessStatusEnumFilter.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value < currentStatus || item.value === 5 || item.value === 7 }))
        }
        break
    }
  })
watch(
  () => dataForm.value.status,
  (val) => {
    isFailedCooperation.value = val === 6
    isRequired.value = (val === 4 || val === 9 || val === 5 || val === 7) && props.type !== 'view'
    setTimeout(() => clearValidate(['failedCooperateId', 'remark']), 0)
  },
  { immediate: true }
)

const handleProductNameChange = (value: number[]) => {
  // dataForm.productName = value[0]
}
const validate = () => {
  return new Promise((resolve, reject) => {
    formRef.value?.validate()
      .then(async (res: any) => {
        resolve(res)
      }).catch((err: any) => {
        reject(err)
      })
  })
}

__expose({ resetFields, validate, clearValidate })

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    scrollToFirstError: "",
    model: dataForm.value,
    ref_key: "formRef",
    ref: formRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_card, {
        title: props.title,
        span: 6
      }, {
        default: _withCtx(() => [
          _createVNode(_component_dc_form_item, {
            label: "客户名称",
            name: "saleChanceRefId",
            rules: formRules.saleChanceRefId
          }, {
            default: _withCtx(() => [
              _createVNode(ClueAndCustomerSelect, {
                appId: "cos_lbu",
                value: dataForm.value.saleChanceRefId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.value.saleChanceRefId) = $event)),
                label: dataForm.value.customerName,
                "onUpdate:label": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.value.customerName) = $event)),
                disabled: !isEdit.value || props.saleChanceRefId,
                view: "",
                placeholder: "请选择客户名称"
              }, null, 8, ["value", "label", "disabled"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_dc_form_item, { label: "始发地国家" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CustomerArea), {
                value: dataForm.value.originCountry,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.value.originCountry) = $event)),
                "change-on-select": "",
                showSearch: "",
                disabled: !isEdit.value,
                "display-level": 1,
                view: "",
                allowClear: ""
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "联系人姓名" }, {
            default: _withCtx(() => [
              _createVNode(CosInput, {
                value: dataForm.value.contactName,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.value.contactName) = $event)),
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "手机号" }, {
            default: _withCtx(() => [
              _createVNode(CosInput, {
                value: dataForm.value.contactMobile,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.value.contactMobile) = $event)),
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, {
            label: "客户归属区域",
            name: "warehouseAttribution",
            rules: formRules.warehouseAttribution
          }, {
            default: _withCtx(() => [
              _createVNode(ParamCodeCascader, {
                label: dataForm.value.warehouseAttributionName,
                "onUpdate:label": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.value.warehouseAttributionName) = $event)),
                value: dataForm.value.warehouseAttribution,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.value.warehouseAttribution) = $event)),
                options: paramCodeData.value.lbu_warehouse_city,
                disabled: !isEdit.value,
                view: ""
              }, null, 8, ["label", "value", "options", "disabled"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_dc_form_item, {
            label: "商机状态",
            name: "status",
            rules: formRules.status
          }, {
            label: _withCtx(() => [
              _createTextVNode(" 商机状态 "),
              _createVNode(_component_a_tooltip, {
                placement: "topLeft",
                overlayStyle: { maxWidth: '900px' }
              }, {
                title: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessStatusEnumFilter.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.value
                    }, [
                      _createElementVNode("p", null, _toDisplayString(item.label) + _toDisplayString(item.desc ? `：${item.desc}` : ''), 1)
                    ]))
                  }), 128))
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_CosSelect, {
                value: dataForm.value.status,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.value.status) = $event)),
                options: businessStatusEnumFilter.value,
                disabled: !isEdit.value,
                view: "",
                allowClear: ""
              }, null, 8, ["value", "options", "disabled"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_dc_form_item, {
            label: "商机类型",
            name: "saleChanceType",
            rules: formRules.saleChanceType
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ParamCodesSelect, {
                value: dataForm.value.saleChanceType,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((dataForm.value.saleChanceType) = $event)),
                options: paramCodeData.value.lbu_sale_chance_type,
                disabled: !isEdit.value,
                view: "",
                allowClear: "",
                "max-tag-count": !isEdit.value ? 100 : 'responsive'
              }, null, 8, ["value", "options", "disabled", "max-tag-count"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_dc_form_item, {
            label: "竞争对手",
            name: "competitors",
            rules: formRules.competitors
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ParamCodesSelect, {
                value: dataForm.value.competitors,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((dataForm.value.competitors) = $event)),
                options: paramCodeData.value.lbu_logistics_service_provider,
                disabled: !isEdit.value,
                view: "",
                allowClear: "",
                mode: "multiple",
                "max-tag-count": !isEdit.value ? 100 : 'responsive'
              }, null, 8, ["value", "options", "disabled", "max-tag-count"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_dc_form_item, {
            label: "协助部门",
            name: "assistDepartment"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ParamCodesSelect, {
                value: dataForm.value.assistDepartment,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((dataForm.value.assistDepartment) = $event)),
                options: paramCodeData.value.lbu_assistance_department,
                disabled: !isEdit.value,
                view: "",
                allowClear: ""
              }, null, 8, ["value", "options", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "客户ID" }, {
            default: _withCtx(() => [
              _createVNode(CosInput, {
                value: dataForm.value.saleChanceRefId,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((dataForm.value.saleChanceRefId) = $event)),
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "商机名称" }, {
            default: _withCtx(() => [
              _createVNode(CosInput, {
                value: dataForm.value.saleChanceNameByTxt,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((dataForm.value.saleChanceNameByTxt) = $event)),
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "商机ID" }, {
            default: _withCtx(() => [
              _createVNode(CosInput, {
                value: dataForm.value.id,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((dataForm.value.id) = $event)),
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "客户负责人" }, {
            default: _withCtx(() => [
              _createVNode(CosInput, {
                value: dataForm.value.dutyByName,
                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((dataForm.value.dutyByName) = $event)),
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "创建人" }, {
            default: _withCtx(() => [
              _createVNode(CosInput, {
                value: dataForm.value.createByName,
                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((dataForm.value.createByName) = $event)),
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "创建时间" }, {
            default: _withCtx(() => [
              _createVNode(CosInput, {
                value: dataForm.value.createTime,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((dataForm.value.createTime) = $event)),
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "更新人" }, {
            default: _withCtx(() => [
              _createVNode(CosInput, {
                value: dataForm.value.updateByName,
                "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((dataForm.value.updateByName) = $event)),
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "更新时间" }, {
            default: _withCtx(() => [
              _createVNode(CosInput, {
                value: dataForm.value.updateTime,
                "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((dataForm.value.updateTime) = $event)),
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          (isFailedCooperation.value)
            ? (_openBlock(), _createBlock(_component_dc_form_item, {
                key: 0,
                label: "未能合作原因",
                name: "failedCooperateId",
                rules: formRules.failedCooperateId
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ParamCodesSelect, {
                    value: dataForm.value.failedCooperateId,
                    "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((dataForm.value.failedCooperateId) = $event)),
                    options: paramCodeData.value.lbu_failure_reason,
                    disabled: !isEdit.value,
                    view: "",
                    allowClear: ""
                  }, null, 8, ["value", "options", "disabled"])
                ]),
                _: 1
              }, 8, ["rules"]))
            : _createCommentVNode("", true),
          _createVNode(_component_dc_form_item, {
            label: "经营模式",
            name: "managementModel",
            class: "form-item_compact"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_group, {
                compact: "",
                class: "cos-view-input-group"
              }, {
                default: _withCtx(() => [
                  _createVNode(ParamCodeCascader, {
                    value: dataForm.value.managementModel,
                    "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((dataForm.value.managementModel) = $event)),
                    cosDes: dataForm.value.managementModelExplain,
                    appId: "cos_lbu",
                    paramCode: "lbu_management_model",
                    status: props.type === 'view' ? undefined : 0,
                    disabled: !isEdit.value,
                    view: "",
                    style: {"width":"33%"}
                  }, null, 8, ["value", "cosDes", "status", "disabled"]),
                  _createVNode(_component_dc_form_item, {
                    name: "managementModelExplain",
                    span: 24,
                    style: {"width":"67%"},
                    class: "last-compact"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: dataForm.value.managementModelExplain,
                        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((dataForm.value.managementModelExplain) = $event)),
                        maxlength: 100,
                        disabled: !isEdit.value,
                        view: ""
                      }, null, 8, ["value", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_dc_layout_card, {
        title: "现有发货量（ER/元）",
        span: 6
      }, {
        default: _withCtx(() => [
          _createVNode(_component_dc_form_item, {
            label: "目的地国家",
            name: "requiredCountry",
            rules: formRules.requiredCountry
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ParamCodesSelect, {
                value: dataForm.value.requiredCountry,
                "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((dataForm.value.requiredCountry) = $event)),
                options: paramCodeData.value.lbu_demand_country,
                disabled: !isEdit.value,
                view: "",
                allowClear: "",
                onChange: handleCountryChange
              }, null, 8, ["value", "options", "disabled"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_dc_form_item, {
            label: "云途产品",
            name: "product",
            rules: formRules.product
          }, {
            default: _withCtx(() => [
              _createVNode(ParamCodeCascader, {
                value: dataForm.value.product,
                "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((dataForm.value.product) = $event)),
                options: paramCodeData.value.lbu_products,
                view: "",
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_dc_form_item, { label: "当前账号上月发货票数" }, {
            default: _withCtx(() => [
              _createVNode(_component_CosInputNumber, {
                value: dataForm.value.ctUitQty,
                "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((dataForm.value.ctUitQty) = $event)),
                "cos-type": "money",
                min: 0,
                maxlength: 15,
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "当前账号去年上月发货票数" }, {
            default: _withCtx(() => [
              _createVNode(_component_CosInputNumber, {
                value: dataForm.value.ctLyUitQty,
                "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((dataForm.value.ctLyUitQty) = $event)),
                "cos-type": "money",
                min: 0,
                maxlength: 15,
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "当前账号前三个月平均发货票数" }, {
            label: _withCtx(() => [
              _createVNode(_component_a_tooltip, {
                placement: "topLeft",
                overlayStyle: { maxWidth: '800px' }
              }, {
                title: _withCtx(() => [
                  _hoisted_1
                ]),
                default: _withCtx(() => [
                  _hoisted_2,
                  _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_CosInputNumber, {
                value: dataForm.value.ctMarQty,
                "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((dataForm.value.ctMarQty) = $event)),
                "cos-type": "money",
                min: 0,
                maxlength: 15,
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "当前账号发货量状态" }, {
            default: _withCtx(() => [
              _createVNode(CosInput, {
                value: dataForm.value.ctQtyStatus,
                "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((dataForm.value.ctQtyStatus) = $event)),
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "主账号上月发货票数" }, {
            default: _withCtx(() => [
              _createVNode(_component_CosInputNumber, {
                value: dataForm.value.uitQty,
                "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((dataForm.value.uitQty) = $event)),
                "cos-type": "money",
                min: 0,
                maxlength: 15,
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "主账号去年上月发货票数" }, {
            default: _withCtx(() => [
              _createVNode(_component_CosInputNumber, {
                value: dataForm.value.lyUitQty,
                "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((dataForm.value.lyUitQty) = $event)),
                "cos-type": "money",
                min: 0,
                maxlength: 15,
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "主账号前三个月平均发货票数" }, {
            label: _withCtx(() => [
              _createVNode(_component_a_tooltip, {
                placement: "topLeft",
                overlayStyle: { maxWidth: '800px' }
              }, {
                title: _withCtx(() => [
                  _hoisted_3
                ]),
                default: _withCtx(() => [
                  _hoisted_4,
                  _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_CosInputNumber, {
                value: dataForm.value.marQty,
                "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((dataForm.value.marQty) = $event)),
                "cos-type": "money",
                min: 0,
                maxlength: 15,
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, { label: "主账号发货量状态" }, {
            default: _withCtx(() => [
              _createVNode(CosInput, {
                value: dataForm.value.qtyStatus,
                "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((dataForm.value.qtyStatus) = $event)),
                view: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          (dataForm.value.status === 5 || dataForm.value.status === 7)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_dc_form_item, { label: "当月新增收入（元）" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInputNumber, {
                      value: dataForm.value.cmAdd,
                      "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((dataForm.value.cmAdd) = $event)),
                      view: "",
                      "cos-type": "money"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "收入环比增长（元）" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInputNumber, {
                      value: dataForm.value.hGrowth,
                      "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((dataForm.value.hGrowth) = $event)),
                      view: "",
                      "cos-type": "money"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "FTB首月收入（元）" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInputNumber, {
                      value: dataForm.value.ftbCm,
                      "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((dataForm.value.ftbCm) = $event)),
                      view: "",
                      "cos-type": "money"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "FTB客户承诺收入（元）" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInputNumber, {
                      value: dataForm.value.ftbCurPro,
                      "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((dataForm.value.ftbCurPro) = $event)),
                      view: "",
                      "cos-type": "money"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_dc_layout_card, {
        title: "潜力信息",
        span: 6
      }, {
        default: _withCtx(() => [
          _createVNode(_component_dc_form_item, {
            label: "OPR票数",
            name: "mau",
            rules: formRules.mau
          }, {
            label: _withCtx(() => [
              _createVNode(_component_a_tooltip, {
                placement: "topLeft",
                overlayStyle: { maxWidth: '800px' }
              }, {
                title: _withCtx(() => [
                  _hoisted_5
                ]),
                default: _withCtx(() => [
                  _hoisted_6,
                  _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_CosInputNumber, {
                style: {"width":"100%"},
                min: 0,
                maxlength: 15,
                "cos-type": "money",
                value: dataForm.value.mau,
                "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((dataForm.value.mau) = $event)),
                disabled: !isEdit.value,
                placeholder: "请输入OPR票数",
                view: "",
                oninput: "value= value.length === 1 ? value.replace(/[^1-9]/g,''):value.replace(/[^\\d]/g,'')"
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_dc_form_item, {
            label: "OPR金额",
            name: "planSaleAmount",
            rules: formRules.planSaleAmount
          }, {
            label: _withCtx(() => [
              _createVNode(_component_a_tooltip, {
                placement: "topLeft",
                overlayStyle: { maxWidth: '800px' }
              }, {
                title: _withCtx(() => [
                  _hoisted_7
                ]),
                default: _withCtx(() => [
                  _hoisted_8,
                  _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_CosInputNumber, {
                style: {"width":"100%"},
                min: 0,
                maxlength: 15,
                "cos-type": "money",
                value: dataForm.value.planSaleAmount,
                "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((dataForm.value.planSaleAmount) = $event)),
                disabled: !isEdit.value,
                oninput: "value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')",
                placeholder: "对应仓库及渠道的OPR金额",
                view: ""
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_dc_form_item, {
            label: "OCR票数",
            name: "committedShipment",
            rules: formRules.committedShipment
          }, {
            label: _withCtx(() => [
              _createVNode(_component_a_tooltip, {
                placement: "topLeft",
                overlayStyle: { maxWidth: '800px' }
              }, {
                title: _withCtx(() => [
                  _hoisted_9
                ]),
                default: _withCtx(() => [
                  _hoisted_10,
                  _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_CosInputNumber, {
                style: {"width":"100%"},
                min: 0,
                maxlength: 15,
                "cos-type": "money",
                value: dataForm.value.committedShipment,
                "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((dataForm.value.committedShipment) = $event)),
                disabled: !isEdit.value,
                placeholder: "请输入OCR票数",
                view: "",
                oninput: "value= value.length === 1 ? value.replace(/[^1-9]/g,''):value.replace(/[^\\d]/g,'')"
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_dc_form_item, {
            label: "OCR金额",
            name: "committedSaleAmount",
            rules: formRules.committedSaleAmount
          }, {
            label: _withCtx(() => [
              _createVNode(_component_a_tooltip, {
                placement: "topLeft",
                overlayStyle: { maxWidth: '800px' }
              }, {
                title: _withCtx(() => [
                  _hoisted_11
                ]),
                default: _withCtx(() => [
                  _hoisted_12,
                  _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_CosInputNumber, {
                style: {"width":"100%"},
                min: 0,
                maxlength: 15,
                "cos-type": "money",
                value: dataForm.value.committedSaleAmount,
                "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((dataForm.value.committedSaleAmount) = $event)),
                disabled: !isEdit.value,
                placeholder: "请输入OCR金额",
                view: "",
                oninput: "value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')"
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }, 8, ["rules"]),
          (isB2BProduct.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_dc_form_item, {
                  label: "OPR重量（KG）",
                  name: "oprWeight",
                  rules: formRules.required
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInputNumber, {
                      style: {"width":"100%"},
                      min: 0,
                      maxlength: 15,
                      "cos-type": "money",
                      value: dataForm.value.oprWeight,
                      "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((dataForm.value.oprWeight) = $event)),
                      disabled: !isEdit.value,
                      placeholder: "请输入",
                      view: "",
                      oninput: "value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "OCR重量（KG）",
                  name: "ocrWeight",
                  rules: isRequired.value ? formRules.required : undefined
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInputNumber, {
                      style: {"width":"100%"},
                      min: 0,
                      maxlength: 15,
                      "cos-type": "money",
                      value: dataForm.value.ocrWeight,
                      "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((dataForm.value.ocrWeight) = $event)),
                      disabled: !isEdit.value,
                      placeholder: "请输入",
                      view: "",
                      oninput: "value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "OPR方数（m³）",
                  name: "oprCube"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInputNumber, {
                      style: {"width":"100%"},
                      min: 0,
                      maxlength: 15,
                      "cos-type": "money",
                      value: dataForm.value.oprCube,
                      "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((dataForm.value.oprCube) = $event)),
                      disabled: !isEdit.value,
                      placeholder: "请输入",
                      view: "",
                      oninput: "value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "OCR方数（m³）",
                  name: "ocrCube"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInputNumber, {
                      style: {"width":"100%"},
                      min: 0,
                      maxlength: 15,
                      "cos-type": "money",
                      value: dataForm.value.ocrCube,
                      "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((dataForm.value.ocrCube) = $event)),
                      disabled: !isEdit.value,
                      placeholder: "请输入",
                      view: "",
                      oninput: "value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "发货频次（次/月）",
                  name: "shipmentFrequency"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInputNumber, {
                      style: {"width":"100%"},
                      min: 0,
                      maxlength: 15,
                      "cos-type": "money",
                      value: dataForm.value.shipmentFrequency,
                      "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((dataForm.value.shipmentFrequency) = $event)),
                      disabled: !isEdit.value,
                      placeholder: "请输入发货频次",
                      view: "",
                      oninput: "value=value.length === 1 ? value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "货物类型",
                  name: "goodsCategory",
                  rules: formRules.goodsCategory
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: dataForm.value.goodsCategory,
                      "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((dataForm.value.goodsCategory) = $event)),
                      options: paramCodeData.value.lbu_sales_category,
                      disabled: !isEdit.value,
                      view: "",
                      allowClear: "",
                      mode: "multiple",
                      "max-tag-count": !isEdit.value ? 100 : 'responsive'
                    }, null, 8, ["value", "options", "disabled", "max-tag-count"])
                  ]),
                  _: 1
                }, 8, ["rules"])
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_a_col, { span: 24 }),
          _createVNode(_component_dc_form_item, {
            label: "竞对情况",
            name: "competitionSituation",
            span: 12,
            rules: formRules.competitionSituation
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosTextarea, {
                value: dataForm.value.competitionSituation,
                "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((dataForm.value.competitionSituation) = $event)),
                maxlength: 2000,
                disabled: !isEdit.value,
                placeholder: "描述竞争对手所释放给该客户的具体价格，账期或其他活动策略，转运时间，货量要求等",
                view: ""
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_dc_form_item, {
            label: "客户情况",
            name: "customerSituation",
            span: 12,
            rules: formRules.customerSituation
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosTextarea, {
                value: dataForm.value.customerSituation,
                "onUpdate:value": _cache[47] || (_cache[47] = ($event: any) => ((dataForm.value.customerSituation) = $event)),
                maxlength: 2000,
                disabled: !isEdit.value,
                placeholder: "客户的营业模式，最近一次沟通和拜访的情况和进度，遇到的问题",
                view: ""
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_dc_form_item, {
            label: "所需支持",
            name: "requiredSupport",
            span: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosTextarea, {
                value: dataForm.value.requiredSupport,
                "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((dataForm.value.requiredSupport) = $event)),
                maxlength: 2000,
                disabled: !isEdit.value,
                placeholder: "针对客户商机转换所需要的支持和帮助内容",
                view: ""
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, {
            label: "备注",
            name: "remark",
            span: 12,
            rules: formRules.remark
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosTextarea, {
                value: dataForm.value.remark,
                "onUpdate:value": _cache[49] || (_cache[49] = ($event: any) => ((dataForm.value.remark) = $event)),
                maxlength: 2000,
                disabled: !isEdit.value,
                placeholder: "其他需要特殊说明的内容，客户货品重量情况等",
                view: ""
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }, 8, ["rules"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})